export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";